import { render, staticRenderFns } from "./DocumentationApi.vue?vue&type=template&id=0d507092&"
import script from "./DocumentationApi.vue?vue&type=script&lang=js&"
export * from "./DocumentationApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports